import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { BasketItem, Branch } from "../../containers/NewOrderContainer/types";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import "./ConfirmDialog.scss";
import getStyles from "./getStyles";
import { CircularProgress } from "@material-ui/core";

const ConfirmDialog = (props: any) => {
  const [submitted, setSubmitted] = useState<boolean>(false);

  useEffect(() => {
    setSubmitted(false);
  }, [props.open]);

  const classes = getStyles();

  function getBranchName(item: BasketItem): string {
    const branch = props.branches.find((b: Branch) => b.id === item.branchId);
    if (branch) {
      return branch.name;
    }
    return "";
  }

  return (
    <Dialog
      fullWidth={true}
      className="Confirm-dialog"
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className={classes.titleBar}>
        {props.returns ? "Confirm Returns" : "Confirm Orders"}
      </DialogTitle>
      <DialogContent>
        <table className="ConfirmDialogTable-container">
          <thead className="ConfirmDialogTable--headPanel">
            <tr className="ConfirmDialogTable--headPanelRow">
              <th>Branch</th>
              <th>Currency</th>
              <th>Currency Amount</th>
              <th>Date Required</th>
            </tr>
          </thead>
          <tbody>
            {props.basketItems &&
              props.basketItems.map((item: BasketItem) => (
                <tr className="ConfirmDialogTable--row">
                  <td>{getBranchName(item)}</td>
                  <td>{item.currency}</td>
                  <td>{item.currencyAmount}</td>
                  <td>{item.required}</td>
                </tr>
              ))}
          </tbody>
        </table>
        {submitted && (
          <div className="Confirm-modal-please-wait">
            <CircularProgress color="inherit" />
            <div className="Confirm-modal-please-wait-message">
              Please wait...
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          className="Confirm-modal-back-button"
          onClick={props.onCancel}
          disabled={submitted}
          color="secondary"
        >
          Back
        </Button>
        <Button
          className="Confirm-modal-confirm-button"
          color="primary"
          autoFocus
          disabled={submitted}
          onClick={() => {
            if (!submitted) {
              setSubmitted(true);
              props.onSubmit();
            }
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
